import { useSuspenseQueries } from '@tanstack/react-query';

import type { NavigationScreenSitesListState } from '@gitbook/app-navigation';
import { useHeadTitle } from '@gitbook/util-react-head';

import { NavigationScreenWithOrganization, useSetAnalyticsScreen } from '../../navigation';
import { apiQuery } from '../../state';
import { SitesListBlankslate } from './SitesListBlankslate';
import { SitesListContent } from './SitesListContent';

/**
 * Sites screen home.
 */
export function SitesListScreen({ screen }: { screen: NavigationScreenSitesListState }) {
    return (
        <NavigationScreenWithOrganization screen={screen}>
            {({ screen }) => (
                <SitesListScreenWithOrganization
                    organizationId={screen.organization}
                    screen={screen}
                />
            )}
        </NavigationScreenWithOrganization>
    );
}

/**
 * Screen listing the sites in an organization.
 */
function SitesListScreenWithOrganization({
    organizationId,
    screen,
}: {
    organizationId: string;
    screen: NavigationScreenSitesListState;
}) {
    useHeadTitle('Docs sites');

    useSetAnalyticsScreen(
        {
            organization: organizationId,
            screen: 'sites',
        },
        [organizationId]
    );

    const [{ data: organization }, { data: organizationContent }] = useSuspenseQueries({
        queries: [
            apiQuery('getOrganizationById', { organizationId }),
            apiQuery('getOrganizationAllContent', { organizationId }),
        ],
    });

    if (organizationContent.sites.length === 0) {
        return <SitesListBlankslate organization={organization} />;
    }

    return (
        <SitesListContent
            organization={organization}
            organizationContent={organizationContent}
            screen={screen}
        />
    );
}
